import React from 'react';
import AtlasV2MetricSpineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2MetricSpineChart';
import useAtlasV2KeywordSearchRequestBuilder from 'src/components/AtlasV2Components/AtlasV2Sidebar/AtlasV2SearchSidebar/useAtlasV2KeywordSearchRequestBuilder';
import AdvancedSearchRequestBuilder from 'src/components/BeaconV2Components/utils/AdvancedSearchRequestBuilder';

/**
 * Ad clicks spline chart on the keywords search page
 */
export default function AtlasV2KeywordAdClicksSplineChart({
  builderFunction
}: {
  builderFunction?: (
    additionalBuilder?: (builder: AdvancedSearchRequestBuilder) => AdvancedSearchRequestBuilder
  ) => (requestBuilder: AdvancedSearchRequestBuilder) => AdvancedSearchRequestBuilder;
}) {
  const keywordSearchRequestBuilder = useAtlasV2KeywordSearchRequestBuilder();
  const builderToUse = builderFunction || keywordSearchRequestBuilder;
  return (
    <AtlasV2MetricSpineChart
      indexName="traffic"
      fieldName="adClicks"
      requestBuilder={builderToUse((builder) => {
        return builder;
      })}
    />
  );
}
